import React, { useEffect, useRef, useState } from "react";
import tClasses from "./Multiselect.module.css";

const Multiselect = ({ options, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [search, setSearch] = useState("");
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearch(""); // ✅ clear search when clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const toggleOption = (value) => {
    let updated;
    if (selected.includes(value)) {
      updated = selected.filter((v) => v !== value);
    } else {
      updated = [...selected, value];
    }
    setSelected(updated);
    onChange?.(updated);
  };

  const toggleSelectAll = () => {
    let updated;
    if (selected.length === options.length) {
      updated = [];
    } else {
      updated = options.map((o) => o.value);
    }
    setSelected(updated);
    onChange?.(updated);
  };

  // ✅ Ensure selected options always appear at the top
  const filteredOptions = options
    .filter((opt) => opt.label.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => {
      const aSelected = selected.includes(a.value);
      const bSelected = selected.includes(b.value);
      if (aSelected === bSelected) return 0;
      return aSelected ? -1 : 1; // Selected first
    });

  return (
    <div className={tClasses.multiSelect} ref={wrapperRef}>
      <div className={tClasses.selected} onClick={toggleDropdown}>
        {/* 🔎 Search input */}
        <input
  type="text"
  value={search}
  onChange={(e) => {
    setSearch(e.target.value);
    setIsOpen(true); // ✅ Automatically open dropdown while typing
  }}
  placeholder={
    selected.length === 0
      ? "Select options..."
      : `${selected.length} selected`
  }
  className={tClasses.searchInput}
  onFocus={() => setIsOpen(true)}
/>

        <span className={tClasses.caret}>{isOpen ? "▲" : "▼"}</span>
      </div>

      {isOpen && (
        <div className={tClasses.dropdown}>
          {/* ✅ Select All */}
          <div className={tClasses.option} onClick={toggleSelectAll}>
            <input
              type="checkbox"
              checked={selected.length === options.length}
              readOnly
            />
            <label style={{ marginLeft: "6px" }}>Select All</label>
          </div>

          {/* ✅ Options (selected always on top) */}
          {filteredOptions.map((opt) => (
            <div
              key={opt.value}
              className={tClasses.option}
              onClick={() => toggleOption(opt.value)} // ✅ click anywhere in row
            >
              <input
                type="checkbox"
                checked={selected.includes(opt.value)}
                readOnly // prevent double toggle from input itself
              />
              <label style={{ marginLeft: "6px" }}>{opt.label}</label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Multiselect;
